import { fromPromise } from 'xstate5';

import type {
  LocationPermissionStatus,
  RequestLocationPermissionOutput,
} from '../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getLocationPermissionStatus = fromPromise<LocationPermissionStatus>(async () => {
  throw new Error('`getLocationPermissionStatus` actor is not provided.');
});

export const requestLocationPermission = fromPromise<RequestLocationPermissionOutput>(async () => {
  throw new Error('`requestLocationPermission` actor is not provided.');
});
